import { z } from 'zod';

export const FindProductsDTOSchema = z.object({
  sku: z.string().optional(),
  barcode: z.string().optional(),
  activeOnly: z.boolean().optional().default(false)
});

export interface FindProductsDTO {
  sku?: string;
  barcode?: string;
  activeOnly?: boolean;
}
